import { BaseViewModel } from "@iot-platform/core";
import type { Station } from "@station/domain/models/station.model.ts";
import { StationGetSelectedUseCase } from "@station/domain/usecases/station-get-selected.usecase.ts";
import { StationRemoveSelectedUseCase } from "@station/domain/usecases/station-remove-selected.usecase.ts";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class StationSelectedMobileViewmodel extends BaseViewModel {
    @observable
    selectedStations: readonly Readonly<Station>[] = [];

    constructor(
        @inject(StationGetSelectedUseCase)
        private readonly stationGetSelectedUseCase: StationGetSelectedUseCase,
        @inject(StationRemoveSelectedUseCase)
        private readonly stationRemoveSelectedUseCase: StationRemoveSelectedUseCase,
    ) {
        super();
        makeObservable(this);
    }

    @action
    override didMount(): void {
        this.initViewData();
    }

    initViewData(): void {
        this.addSub(
            this.stationGetSelectedUseCase.execute().subscribe((stations) => {
                runInAction(() => {
                    this.selectedStations = stations;
                });
            }),
        );
    }

    @action
    removeStation(station: Readonly<Station> | Readonly<Station>[]): void {
        this.stationRemoveSelectedUseCase.execute(station);
    }
}
